export enum PopupType {
  AutoplayModified = 'AutoplayModified',
  AutoplayStopped = 'AutoplayStopped',
  BetNotAllowed = 'BetNotAllowed',
  BetNotOnTime = 'BetNotOnTime',
  ConnectionLost = 'ConnectionLost',
  CustomPopup = 'CustomPopup',
  DontLeaveRoundInProgress = 'DontLeaveRoundInProgress',
  ExitConfirmation = 'ExitConfirmation',
  GenericError = 'GenericError',
  SessionExpired = 'SessionExpired',
  Inactivity = 'Inactivity',
  InsufficientFunds = 'InsufficientFunds',
  LoggedOut = 'LoggedOut',
  NicknameEnter = 'NicknameEnter',
  PlayerLimit = 'PlayerLimit',
  RealityCheck = 'RealityCheck',
  Reconnecting = 'Reconnecting',
  SessionBalance = 'SessionBalance',
  TableClosed = 'TableClosed',
  PrivateTableOccupied = 'PrivateTableOccupied',
  VipTableLowBalance = 'VipTableLowBalance',
  VideoIsDisabled = 'VideoIsDisabled',
  VideoStreamQuality = 'VideoStreamQuality',
  SessionBalanceError = 'SessionBalanceError',
  PromoRoundLimit = 'PromoRoundLimit',
  Error = 'Error',
  ByInvitation = 'ByInvitation',
}
